import React from "react";
import {CalendarArrowDown, Flame, MessagesSquare, Sparkles, ArrowBigDown, ArrowBigUp} from "lucide-react";

import { Localizer } from "@/main/react/Types";
import { DiscussionOpeningThoughtOrderingStyle, normalizeDiscussionOpeningThoughtOrdering } from "@/main/react/discussion/OpeningThoughtGroupTypes";

export { normalizeDiscussionOpeningThoughtOrdering };
export type { DiscussionOpeningThoughtOrderingStyle };

// Per-option test hooks, same convention as the publish-language select. Added 2026-08-07: the
// ordering control had no hook on its items, so nothing could drive it and the one spec that changes
// ordering (discussion-pinned-thought) goes through `?openingArgumentOrdering` instead — which left
// the control itself with no owner. See
// designs/08-audits-and-process/comment-feature-test-coverage-audit-2026-08-07.md (G6/R4).
const orderingOptionPlaywrightId = (key: DiscussionOpeningThoughtOrderingStyle) =>
    `discussion-opening-thought-ordering-option-${key}`;

export function getDiscussionOpeningThoughtOrderingOptions(localizer: Localizer) {
    return [
        { key: "best", value: "best", label: localizer("discussion.thoughts.ordering.best"), icon: Sparkles, dataPlaywrightId: orderingOptionPlaywrightId("best") },
        { key: "controversial", value: "controversial", label: localizer("discussion.thoughts.ordering.controversial"), icon: Flame, dataPlaywrightId: orderingOptionPlaywrightId("controversial") },
        { key: "new", value: "new", label: localizer("discussion.thoughts.ordering.new"), icon: CalendarArrowDown, dataPlaywrightId: orderingOptionPlaywrightId("new") },
        { key: "old", value: "old", label: localizer("discussion.thoughts.ordering.old"), icon: CalendarArrowDown, dataPlaywrightId: orderingOptionPlaywrightId("old") },
        { key: "agreed", value: "agreed", label: localizer("discussion.thoughts.ordering.upvoted"), icon: ArrowBigUp, dataPlaywrightId: orderingOptionPlaywrightId("agreed") },
        { key: "disagreed", value: "disagreed", label: localizer("discussion.thoughts.ordering.downvoted"), icon: ArrowBigDown, dataPlaywrightId: orderingOptionPlaywrightId("disagreed") },
        { key: "conversations", value: "conversations", label: localizer("discussion.thoughts.ordering.conversations"), icon: MessagesSquare, dataPlaywrightId: orderingOptionPlaywrightId("conversations") },
    ] satisfies Array<{
        key: DiscussionOpeningThoughtOrderingStyle;
        value: DiscussionOpeningThoughtOrderingStyle;
        label: React.ReactNode;
        icon: React.ElementType;
        dataPlaywrightId: string;
    }>;
}
